import { FC } from 'react';
import clsx from 'clsx';
import { BoxStatusCardData } from '../../pages/sensors-v2/types/sensors';
import { AlarmTypeChip } from './AlarmTypeChip';
import { maxSeverity, severityColor } from './severity';

export type BoxStatusCardVariant = 'full' | 'compact' | 'inline-detail';

type Props = {
  data: BoxStatusCardData;
  variant: BoxStatusCardVariant;
  onClick?: () => void;
  onClearAlarms?: () => void;
  isSelected?: boolean;
};

export const BoxStatusCard: FC<Props> = ({ data, variant, onClick, onClearAlarms, isSelected }) => {
  const sev = data.active_alarms.length > 0 ? maxSeverity(data.active_alarms) : 'low';
  const bar = severityColor(sev).bar;

  if (variant === 'inline-detail') {
    return (
      <div className="bg-white border rounded p-3" style={{ borderColor: '#e5e7eb' }}>
        <div className="d-flex flex-wrap" style={{ gap: 4 }}>
          {data.active_alarms.map((a, i) => <AlarmTypeChip key={i} alarm={a} />)}
          {data.active_alarms.length === 0 && (
            <span className="text-muted fs-7">Sem alarmes ativos.</span>
          )}
        </div>
      </div>
    );
  }

  const clickable = !!onClick;
  return (
    <div
      role={clickable ? 'button' : undefined}
      onClick={onClick}
      className={clsx('bg-white d-flex shadow-sm', { 'border-primary': isSelected })}
      style={{
        borderRadius: 8,
        overflow: 'hidden',
        border: isSelected ? '2px solid #2563eb' : '1px solid #e5e7eb',
        cursor: clickable ? 'pointer' : 'default',
        marginBottom: 8,
      }}
    >
      <div style={{ width: 4, background: bar }} />
      <div style={{ padding: variant === 'compact' ? 8 : 12, flex: 1 }}>
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <div style={{ fontWeight: 700, fontSize: 14 }}>CMB {data.cmb_number}</div>
            {variant === 'full' && (
              <div className="text-muted" style={{ fontSize: 11 }}>
                {[data.company_name, data.project_name].filter(Boolean).join(' · ')}
              </div>
            )}
          </div>
          <span style={{
            background: severityColor(sev).bg, color: severityColor(sev).text,
            padding: '2px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600,
          }}>
            {data.total_active_alarms} alarme{data.total_active_alarms === 1 ? '' : 's'}
          </span>
        </div>
        {variant === 'full' && (
          <div className="d-flex flex-wrap mt-2" style={{ gap: 4 }}>
            {data.active_alarms.map((a, i) => <AlarmTypeChip key={i} alarm={a} />)}
          </div>
        )}
        {variant === 'full' && onClearAlarms && (
          <button
            type="button"
            className="btn btn-sm btn-light mt-2"
            onClick={(e) => { e.stopPropagation(); onClearAlarms(); }}
            style={{ fontSize: 11 }}
          >
            🧹 Limpar alarmes
          </button>
        )}
      </div>
    </div>
  );
};
